import { render, staticRenderFns } from "./RightItemView1.vue?vue&type=template&id=70224a8a&scoped=true&"
import script from "./RightItemView1.vue?vue&type=script&lang=ts&"
export * from "./RightItemView1.vue?vue&type=script&lang=ts&"
import style0 from "./RightItemView1.vue?vue&type=style&index=0&id=70224a8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70224a8a",
  null
  
)

export default component.exports